import React, { Component } from "react";
import { API, Storage } from "aws-amplify";
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, HelpBlock, Checkbox, Radio } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import config from "../config/aws";
import "./Habits.css";

export default class Habits extends Component {
  constructor(props) {
    super(props);

    this.file = null;

    this.state = {
      isLoading: null,
      isDeleting: null,
      content: "",
    };
  }

  async componentDidMount() {
    try {
      const habit = await this.getHabit();
      const content = habit.content;
      const days = habit.days.values;
      this.setState({
        content: content,
        days: days
      });
    } catch (e) {
      alert(e);
    }
  }

  getHabit() {
    return API.get("habits", `/habits/${this.props.match.params.id}`);
  }

  validateForm() {
    return this.state.content.length > 0 && Object.keys(this.state.days).length > 0;
  }

  handleDaysChange = event => {
    var newDays = this.state.days;
    if (event.target.checked) {
      newDays.push(event.target.value);
    } else {
      newDays.splice( newDays.indexOf(event.target.value), 1 );
    }
    this.setState({
      days: newDays
    });
  }

  handleContentChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  saveHabit(habit) {
    return API.put("habits", `/habits/${this.props.match.params.id}`, {
      body: habit
    });
  }

  handleSubmit = async event => {
    let attachment;

    event.preventDefault();

    this.setState({ isLoading: true });
    try {
      await this.saveHabit({
        content: this.state.content.toLowerCase(),
        days: this.state.days
      });
      this.props.history.push("/");
    } catch (e) {
      alert(e);
      this.setState({ isLoading: false });
    }
  }

  deleteHabit() {
    return API.del("habits", `/habits/${this.props.match.params.id}`);
  }

  handleDelete = async event => {
    event.preventDefault();

    const confirmed = window.confirm(
      "Are you sure you want to delete this habit?"
    );

    if (!confirmed) {
      return;
    }

    this.setState({ isDeleting: true });

    try {
      await this.deleteHabit();
      this.props.history.push("/");
    } catch (e) {
      alert(e);
      this.setState({ isDeleting: false });
    }
  }

  getDaysCheckbox () {
    return (
      <FormGroup controlId="days" onChange={this.handleDaysChange}>
        <Checkbox inline value="Sunday" defaultChecked={this.state.days.includes("Sunday")}>Su</Checkbox>
        <Checkbox inline value="Monday" defaultChecked={this.state.days.includes("Monday")}>M</Checkbox>
        <Checkbox inline value="Tuesday" defaultChecked={this.state.days.includes("Tuesday")}>T</Checkbox>
        <Checkbox inline value="Wednesday" defaultChecked={this.state.days.includes("Wednesday")}>W</Checkbox>
        <Checkbox inline value="Thursday" defaultChecked={this.state.days.includes("Thursday")}>Th</Checkbox>
        <Checkbox inline value="Friday" defaultChecked={this.state.days.includes("Friday")}>F</Checkbox>
        <Checkbox inline value="Saturday" defaultChecked={this.state.days.includes("Saturday")}>Sa</Checkbox>
      </FormGroup>
    )
  }

  render() {
    return (
      <div className="Habits">
        { this.state.days ?
          <form onSubmit={this.handleSubmit}>
            <FormGroup bsSize="large" controlId="content"  onChange={this.handleContentChange}>
              <ControlLabel>Habit Name</ControlLabel>
              <FormControl
                type="text"
                defaultValue={this.state.content}
              />
            </FormGroup>
            <ControlLabel>Days</ControlLabel>

            {this.getDaysCheckbox()}

            <HelpBlock>Days you want to do your habit</HelpBlock>
            <LoaderButton
              block
              className="success"
              bsSize="large"
              disabled={!this.validateForm()}
              type="submit"
              isLoading={this.state.isLoading}
              text="Save"
              loadingText="Saving…"
            />
            <LoaderButton
              block
              className="cancel"
              bsSize="large"
              isLoading={this.state.isDeleting}
              onClick={this.handleDelete}
              text="Delete"
              loadingText="Deleting…"
            />
          </form>
          : null
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Habits.js